// ==============================================
// COUNTRY-BASED PRICING AND DELIVERY LOGIC
// ==============================================

let pricingMap = {
  SINGAPORE: { currency: "SG$", price: 130, gift_price: 155, cost: 6.3 },
  "UNITED ARAB EMIRATES": { currency: "AED", price: 365, gift_price: 425, cost: 17.5 },
  "UNITED KINGDOM": { currency: "£", price: 75, gift_price: 90, cost: 4.0 },
  "NEW ZEALAND": { currency: "NZ$", price: 165, gift_price: 195, cost: 5.95 },
  CANADA: { currency: "CA$", price: 135, gift_price: 165, cost: 5.95 },
  AUSTRALIA: { currency: "$", price: 99, gift_price: 120, cost: 4.95 },
  "UNITED STATES": { currency: "$", price: 99, gift_price: 120, cost: 4.95 },
  AUSTRIA: { currency: "€", price: 84, gift_price: 99, cost: 4.25 },
  ITALY: { currency: "€", price: 84, gift_price: 99, cost: 4.25 },
  BELGIUM: { currency: "€", price: 84, gift_price: 99, cost: 4.25 },
  ESTONIA: { currency: "€", price: 84, gift_price: 99, cost: 4.25 },
  GERMANY: { currency: "€", price: 84, gift_price: 99, cost: 4.25 },
  FINLAND: { currency: "€", price: 84, gift_price: 99, cost: 4.25 },
  FRANCE: { currency: "€", price: 84, gift_price: 99, cost: 4.25 },
  GREECE: { currency: "€", price: 84, gift_price: 99, cost: 4.25 },
  CROATIA: { currency: "€", price: 84, gift_price: 99, cost: 4.25 },
  IRELAND: { currency: "€", price: 84, gift_price: 99, cost: 4.25 },
  LITHUANIA: { currency: "€", price: 84, gift_price: 99, cost: 4.25 },
  LUXEMBOURG: { currency: "€", price: 84, gift_price: 99, cost: 4.25 },
  LATVIA: { currency: "€", price: 84, gift_price: 99, cost: 4.25 },
  MONACO: { currency: "€", price: 84, gift_price: 99, cost: 4.25 },
  MONTENEGRO: { currency: "€", price: 84, gift_price: 99, cost: 4.25 },
  MALTA: { currency: "€", price: 84, gift_price: 99, cost: 4.25 },
  KOSOVO: { currency: "€", price: 84, gift_price: 99, cost: 4.25 },
  SPAIN: { currency: "€", price: 84, gift_price: 99, cost: 4.25 },
  NETHERLANDS: { currency: "€", price: 84, gift_price: 99, cost: 4.25 },
  PORTUGAL: { currency: "€", price: 84, gift_price: 99, cost: 4.25 },
  SLOVENIA: { currency: "€", price: 84, gift_price: 99, cost: 4.25 },
  SLOVAKIA: { currency: "€", price: 84, gift_price: 99, cost: 4.25 },
  "SAN MARINO": { currency: "€", price: 84, gift_price: 99, cost: 4.25 },
  "VATICAN CITY": { currency: "€", price: 84, gift_price: 99, cost: 4.25 },
  ANDORRA: { currency: "€", price: 84, gift_price: 99, cost: 4.25 },
  CYPRUS: { currency: "€", price: 84, gift_price: 99, cost: 4.25 },
  REST: { currency: "$", price: 99, gift_price: 120, cost: 4.95 },
};

let conversionRateMap = {
  SINGAPORE: { currency: "SG$", rate: 1.35 },
  "UNITED ARAB EMIRATES": { currency: "AED", rate: 3.8 },
  "UNITED KINGDOM": { currency: "£", rate: 0.79 },
  "NEW ZEALAND": { currency: "NZ$", rate: 1.81 },
  CANADA: { currency: "CA$", rate: 1.45 },
  AUSTRALIA: { currency: "$", rate: 1 },
  CYPRUS: { currency: "€", rate: 0.87 },
  ESTONIA: { currency: "€", rate: 0.87 },
  FINLAND: { currency: "€", rate: 0.87 },
  FRANCE: { currency: "€", rate: 0.87 },
  GERMANY: { currency: "€", rate: 0.87 },
  IRELAND: { currency: "€", rate: 0.87 },
  ITALY: { currency: "€", rate: 0.87 },
  LATVIA: { currency: "€", rate: 0.87 },
  LITHUANIA: { currency: "€", rate: 0.87 },
  LUXEMBOURG: { currency: "€", rate: 0.87 },
  MALTA: { currency: "€", rate: 0.87 },
  NETHERLANDS: { currency: "€", rate: 0.87 },
  PORTUGAL: { currency: "€", rate: 0.87 },
  "SAN MARINO": { currency: "€", rate: 0.87 },
  SLOVAKIA: { currency: "€", rate: 0.87 },
  SLOVENIA: { currency: "€", rate: 0.87 },
  SPAIN: { currency: "€", rate: 0.87 },
  "VATICAN CITY": { currency: "€", rate: 0.87 },
  REST: { currency: "$", rate: 1 },
};

const monthNames = ["Jan.", "Feb.", "Mar.", "Apr.", "May.", "Jun.", "Jul.", "Aug.", "Sep.", "Oct.", "Nov.", "Dec."];

const europeanCountries = [
  "Albania", "Andorra", "Austria", "Belarus", "Belgium", "Bosnia and Herzegovina", "Bulgaria", "Croatia", "Cyprus",
  "Czech Republic", "Denmark", "Estonia", "Finland", "France", "Germany", "Greece", "Hungary", "Iceland", "Ireland",
  "Italy", "Kosovo", "Latvia", "Liechtenstein", "Lithuania", "Luxembourg", "Malta", "Moldova", "Monaco", "Montenegro",
  "Netherlands", "North Macedonia", "Norway", "Poland", "Portugal", "Romania", "Russia", "San Marino", "Serbia",
  "Slovakia", "Slovenia", "Spain", "Sweden", "Switzerland", "Ukraine", "Vatican City"
];

const unitedKingdom = ["United Kingdom"];
const us = ["United States", "Canada"];
const aus = ["Australia", "New Zealand"];
const countriesForPriceElements = { CANADA: "CA", "NEW ZEALAND": "NZ" };

function isWeekend(date) {
  const day = date.getDay();
  return day === 0 || day === 6;
}

function addWorkingDays(startDate, numWorkingDays) {
  let resultDate = new Date(startDate);
  while (numWorkingDays > 0) {
    resultDate.setDate(resultDate.getDate() + 1);
    if (!isWeekend(resultDate)) numWorkingDays--;
  }
  return resultDate;
}

function calculateDeliveryDates(countryName) {
  let startOffset = 0;
  let endOffset = 0;

  if (europeanCountries.some(c => c.toLowerCase() === countryName.toLowerCase())) {
    startOffset = 5; endOffset = 11;
  } else if (unitedKingdom.some(c => c.toLowerCase() === countryName.toLowerCase())) {
    startOffset = 3; endOffset = 9;
  } else if (us.some(c => c.toLowerCase() === countryName.toLowerCase())) {
    startOffset = 3; endOffset = 9;
  } else if (aus.some(c => c.toLowerCase() === countryName.toLowerCase())) {
    startOffset = 3; endOffset = 7;
  } else {
    startOffset = 6; endOffset = 13;
  }

  const startDate = new Date();

  const sinceDateFastest = addWorkingDays(startDate, startOffset - 2);
  const beforeDateFastest = addWorkingDays(startDate, endOffset - 2);

  const formatDate = (date, country) => {
    const day = date.getDate();
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return (country === "United States" || country === "Canada")
      ? `${month} ${day} ${year}`
      : `${day} ${month} ${year}`;
  };

  const formattedDate = `${formatDate(sinceDateFastest, countryName)} - ${formatDate(beforeDateFastest, countryName)}`;
  Array.from(document.getElementsByClassName("delivery_date")).forEach(el => el.textContent = formattedDate);
}

function extractAmount(str) {
  // Keep only digits, commas, dots, and minus signs
  let cleaned = str.replace(/[^\d.,-]/g, '').trim();

  // Remove leading dots or commas before any digits
  cleaned = cleaned.replace(/^[.,]+/, '');

  // Detect which symbol is the decimal separator
  const lastComma = cleaned.lastIndexOf(',');
  const lastDot = cleaned.lastIndexOf('.');

  let decimalSeparator = null;

  if (lastComma > -1 && lastDot > -1) {
    // Both exist → whichever comes later is likely the decimal separator
    decimalSeparator = lastComma > lastDot ? ',' : '.';
  } else if (lastComma > -1) {
    decimalSeparator = ',';
  } else if (lastDot > -1) {
    decimalSeparator = '.';
  }

  // Remove thousand separators and normalize to standard dot-decimal
  let normalized = cleaned;
  if (decimalSeparator === ',') {
    // European style: 1.234,56 → 1234.56
    normalized = normalized.replace(/\./g, '').replace(',', '.');
  } else if (decimalSeparator === '.') {
    // US style: 1,234.56 → 1234.56
    normalized = normalized.replace(/,/g, '');
  }

  // Convert to number
  const amount = parseFloat(normalized);

  // Return NaN if not a valid number
  return isNaN(amount) ? NaN : amount;
}

function convertAmount(originalAmount, conversionRate) {
  return Math.ceil(originalAmount * conversionRate).toFixed(0);
}

document.addEventListener("DOMContentLoaded", function () {
  const freeShippingPrices = document.getElementsByClassName("free_shipping_price");
  const freeGiftPrices = document.getElementsByClassName("free_gift_price");
  const freeShippingCosts = document.getElementsByClassName("free_shipping_cost");
  const deliveryCountries = document.getElementsByClassName("delivery_country");
  const priceElements = document.getElementsByClassName("price-australia");
  const convertiblePrices = document.getElementsByClassName("currency_convertible");

  if (freeShippingPrices.length || freeGiftPrices.length || freeShippingCosts.length || deliveryCountries.length || priceElements.length || convertiblePrices.length) {
    fetch("https://robify.ezapp.ovh/country?justcountry=1")
      .then(res => res.text())
      .then(country => {
        try {
          let processed = country.split(", ")[0].split(" (")[0];
          const pricing = pricingMap[processed.toUpperCase()] || pricingMap.REST;

          Array.from(freeShippingPrices).forEach(e => e.innerText = `${pricing.currency}${pricing.price}`);
          Array.from(freeGiftPrices).forEach(e => e.innerText = `${pricing.currency}${pricing.gift_price}`);
          Array.from(freeShippingCosts).forEach(e => e.innerText = `${pricing.currency}${pricing.cost}`);
          Array.from(deliveryCountries).forEach(e => e.innerText = processed);

          const countryUpper = processed.trim().toUpperCase();
          if (countriesForPriceElements[countryUpper]) {
            Array.from(priceElements).forEach(e => e.textContent = countriesForPriceElements[countryUpper]);
          }

          const converted = conversionRateMap[processed] || conversionRateMap["REST"];
          for (let i = 0; i < convertiblePrices.length; i++) {
            const amountToConvert = extractAmount(convertiblePrices[i].innerHTML);
            let preDefinedPrice = convertiblePrices[i].getAttribute("data-price");
            if (preDefinedPrice) {
              preDefinedPrice = preDefinedPrice / 100;
            }
            if (convertiblePrices[i].getAttribute("data-convert") === "false") {
              convertiblePrices[i].innerHTML =
                converted.currency + (preDefinedPrice ?? amountToConvert);
            } else {
              convertiblePrices[i].innerHTML =
                converted.currency + convertAmount(preDefinedPrice ?? amountToConvert, converted.rate);
            }
          }

          calculateDeliveryDates(processed.toLowerCase());
        } catch (e) {
          console.error("Unable to update free shipping pricing:", e);
        }
      });
  }
});

// ===============================
// CART PAGE SCRIPTS
// ===============================

$(document).ready(function () {
  // Utility: Add commas to numbers
  function numberWithCommas(number) {
    var parts = number.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }

  // ===============================
  // Check All Cart Items
  // ===============================
  $(document).on("change", "#ckbCheckAll", function () {
    const $cartTotal = $(".cart-page-subtotal").children().find(".money");
    const totalAttr = $(".cart-page-subtotal").attr("data-maintotal-price");

    if ($(this).is(":checked")) {
      $(".custom-cart-note").hide();

      $(".checkBoxClass").each(function () {
        const $this = $(this);
        $this.prop("checked", true);

        const parent = $this.closest(".cart__item");
        const productTitle = parent.find(".cart__item--title").text();
        const productQty = parent.find(".quantity").val();
        const currency = parent.find(".modal_price .money").attr("data-currency");
        const price = parseFloat(parent.find(".modal_price .money.mainprice").attr("data-money"));
        const productId = $this.val();

        const totalPrice = price * productQty;

        if (!$(`.overview-product[data-id="${productId}"]`).length) {
          const html = `
            <li class="overview-product" data-id="${productId}">
              <div class="overview-product-box">
                <span class="overview-product-qty">${productQty} X</span>
                <span class="overview-product-title">${productTitle}</span>
              </div>
              <div class="overvie-title">
                <span class="overview-product-price" data-price="${totalPrice}">
                  ${currency}${numberWithCommas(totalPrice.toFixed(2))}
                </span>
              </div>
            </li>`;
          $(".cartsubtotalitem").append(html);
        } else {
          const $existing = $(`.overview-product[data-id="${productId}"]`);
          $existing.find(".overview-product-title").text(productTitle);
          $existing.find(".overview-product-qty").text(`${productQty} X`);
          $existing.find(".overview-product-price")
            .text(`${currency}${numberWithCommas(totalPrice.toFixed(2))}`)
            .attr("data-price", price);
        }

        $cartTotal.text(`${currency}${numberWithCommas(parseFloat(totalAttr).toFixed(2))}`);
        $cartTotal.attr("data-total-price", numberWithCommas(parseFloat(totalAttr).toFixed(2)));
      });
    } else {
      $(".checkBoxClass").each(function () {
        const $this = $(this);
        const productId = $this.val();
        $this.prop("checked", false);
        $(`.overview-product[data-id="${productId}"]`).remove();
      });
    }
  });

  // ===============================
  // Individual Cart Item Checkbox
  // ===============================
  $(document).on("change", ".cart__item .checkBoxClass", function () {
    const $this = $(this);
    const parent = $this.closest(".cart__item");
    const productTitle = parent.find(".cart__item--title").text();
    const productQty = parent.find(".quantity").val();
    const currency = parent.find(".modal_price .money").attr("data-currency");
    const price = parseFloat(parent.find(".modal_price .money.mainprice").attr("data-money"));
    const productId = $this.val();
    const totalPrice = price * productQty;
    const $cartTotal = $(".cart-page-subtotal").children().find(".money");

    if ($this.is(":checked")) {
      $(".custom-cart-note").hide();
      $(".overview-product").css("display", "flex");

      if (!$(`.overview-product[data-id="${productId}"]`).length) {
        const html = `
          <li class="overview-product" data-id="${productId}" style="display:flex;">
            <div class="overview-product-box">
              <span class="overview-product-qty">${productQty} X</span>
              <span class="overview-product-title">${productTitle}</span>
            </div>
            <div class="overvie-title">
              <span class="overview-product-price" data-price="${totalPrice}">
                ${currency}${numberWithCommas(totalPrice.toFixed(2))}
              </span>
            </div>
          </li>`;
        $(".cartsubtotalitem").append(html);
      } else {
        const $existing = $(`.overview-product[data-id="${productId}"]`);
        $existing.find(".overview-product-title").text(productTitle);
        $existing.find(".overview-product-qty").text(`${productQty} X`);
        $existing.find(".overview-product-price")
          .text(`${currency}${numberWithCommas(totalPrice.toFixed(2))}`)
          .attr("data-price", price);
      }
    } else {
      $(`.overview-product[data-id="${productId}"]`).remove();
      $("#ckbCheckAll").prop("checked", false);
    }

    // Calculate Total
    let total = 0;
    $(".cart__item .checkBoxClass:checked").each(function () {
      const itemPrice = parseFloat($(this).closest(".cart__item").find(".price_total .money").attr("data-money"));
      total += itemPrice;
    });

    $cartTotal.text(`${currency}${numberWithCommas(total.toFixed(2))}`);
    $cartTotal.attr("data-total-price", numberWithCommas(total.toFixed(2)));
  });

  // ===============================
  // Custom Checkout Button
  // ===============================
  $("#customcheckout").click(function () {
    const uncheckedCount = $("input.checkBoxClass:checkbox:not(:checked)").length;
    const totalItems = $(".cart__item").length;

    if ($(".ckbCheckAll").prop("checked")) {
      $("#checkout").trigger("click");
      return;
    }

    const lineItems = [];
    $(".cart__item").each(function () {
      const $checkbox = $(this).find(".checkBoxClass");
      const id = $checkbox.attr("data-id-key");
      if (!$checkbox.is(":checked")) lineItems.push(id);
    });

    const data = { updates: {} };
    lineItems.forEach(id => (data.updates[id] = 0));

    if (totalItems === uncheckedCount) {
      $(".custom-cart-note").show();
    } else {
      $(".custom-cart-note").hide();
      $.ajax({
        type: "POST",
        url: "/cart/update.js",
        data,
        dataType: "json",
        success() {
          $("#checkout").trigger("click");
        },
      });
    }
  });

  // ===============================
  // Discount Code Auto Checkout
  // ===============================
  $(".discount-button").click(function () {
    if ($(".discount-code input").val().length > 0) {
      $("#customcheckout").trigger("click");
    }
  });

  // ===============================
  // Prevent Manual Quantity Edit
  // ===============================
  $(".product-quantity-block .quantity").keydown(() => false);

  // ===============================
  // Scroll to Main Add to Cart
  // ===============================
  $(".extra-add-to-cart .add_to_cart").on("click", function (event) {
    event.preventDefault();
    const target = $(this).attr("data-href");
    $("html, body").animate(
      { scrollTop: $(target).offset().top - 150 },
      1000
    );
  });

  // ===============================
  // Add iframe Classes to Parent
  // ===============================
  $(".product_banner iframe").each(function () {
    const className = $(this).attr("class");
    $(this).closest("div").addClass(className);
  });

  $(".gift-code-box").click(function () {
    // Placeholder for gift code interaction
  });
});

// ===============================
// WINDOW SCROLL / RESIZE LOGIC
// ===============================
function isFullyInViewport($el) {
  const elementTop = $el.offset().top;
  const elementBottom = elementTop + $el.outerHeight();
  const viewportTop = $(window).scrollTop();
  const viewportBottom = viewportTop + $(window).height();

  return (
    elementTop >= viewportTop &&
    elementBottom <= viewportBottom &&
    elementTop <= viewportBottom &&
    elementBottom >= viewportTop
  );
}

// Extra ATC visibility toggle on product pages
$(window).on("resize scroll", function () {
  if ($("body.custom-productpage").length) {
    const div = $(".shopify-product-form").position();
    if (div) {
      const scrollTo = div.top + $(".shopify-product-form").height();
      if ($(this).scrollTop() > scrollTo) {
        $(".extra-add-to-cart").removeClass("hidden");
      } else {
        $(".extra-add-to-cart").addClass("hidden");
      }
    }
  }
});

// Sticky checkout button behavior on cart pages
$(window).on("resize scroll", function () {
  if ($("body.custom-cartpage").length) {
    const div = $(".continue-shopping").position();
    if (div) {
      const scrollTo = div.top + $(".continue-shopping").height();
      const $checkoutBtn = $(".tos_warning.checkout_button");

      if ($(this).scrollTop() > scrollTo) {
        $checkoutBtn.removeClass("non-sticky").addClass("chk-sticky");
      } else {
        $checkoutBtn.addClass("non-sticky").removeClass("chk-sticky");
      }
    }
  }
});

function guaranteed(its, first = false) {
  lfc_container = document.getElementById('lfc_container');
  if (!lfc_container) {
    return;
  }
  if (its) {
    var msgtoset = '🎁 <b>Guaranteed</b> Christmas Delivery!';
    lfc_container.style.display = 'block';
  } else {
    var msgtoset = 'Christmas delivery not guaranteed';
    lfc_container.style.display = 'block';

    if (first) {
      lfc_container.innerHTML = '';
      lfc_container.style.display = 'none';
      return;
    }
  }

  if (lfc_container.innerHTML != msgtoset) {
    lfc_container.innerHTML = msgtoset;
    lfc_container.style.display = 'block';
  }
}

function getFormattedDate() {
  const options = { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit' };
  const londonDate = new Date().toLocaleDateString('en-GB', options);

  // The result from toLocaleDateString will be in the format dd/mm/yyyy
  // We need to split it and rearrange to yyyy-mm-dd
  const [day, month, year] = londonDate.split('/');
  return `${year}-${month}-${day}`;
}

function LFCfindGetParameter(parameterName) {
  var result = null,
    tmp = [];
  location.search
    .substr(1)
    .split('&')
    .forEach(function (item) {
      tmp = item.split('=');
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });
  return result;
}

function getLFCVID() {
  var vid = LFCfindGetParameter('variant');
  if (vid === null) {
    vid = meta.product.variants[0].id;
  }
  return vid;
}

var deliveryGuaranteedCountries = ['UNITED STATES', 'ITALY', 'SPAIN'];

function checkDESTwenty(changedVariant = false) {
  var vid = getLFCVID();
  var firstSKU = false;
  for (i = 0; i < meta.product.variants.length; i++) {
    if (meta.product.variants[i].id == vid) {
      var targetVariantId = meta.product.variants[i].id;
      if (i == 0 && !changedVariant) {
        firstSKU = true; // hide box on landing
        //firstSKU = false; // show box on landing
      }
      if (typeof variantQuantities !== 'undefined') {
        if (variantQuantities[targetVariantId] && variantQuantities[targetVariantId] > 1) {
          // The variant exists in the array and has a value greater than 0
          guaranteed(true);
          return;
        }
      }
      guaranteed(false, firstSKU);
      return;
    }
  }
}

function checkDeliveryGuarantee() {
  if (deliveryGuaranteedCountries.includes(window.actualcountry.trim())) {
    options = document.getElementsByClassName('selectedoption');
    for (j = 0; j < options.length; j++) {
      options[j].addEventListener('change', function () {
        setTimeout(function () {
          checkDESTwenty(true);
        }, 100);
      });
    }

    checkDESTwenty();
  } else {
    guaranteed(false);
  }
}

if (getFormattedDate() >= '2024-12-16') {
  if (getFormattedDate() >= '2024-12-18') {
    if (getFormattedDate() <= '2024-12-23') {
      guaranteed(false);
    }
  } else {
    guaranteed(false, true);
    fetch('https://robify.ezapp.ovh/country?justcountry=1')
      .then((response) => response.text())
      .then((country) => {
        window.actualcountry = country;

        checkDeliveryGuarantee();
      })
      .catch((error) => {
        console.error('Error during #1 HTTP request: ' + error.message);
        guaranteed(false, true);
      });
  }
}

function attachGiftBagListener() {
  const giftBagCheckbox = document.getElementById('giftBag');
  if (giftBagCheckbox) {
    options = document.getElementsByClassName('selectedoption');
    for (j = 0; j < options.length; j++) {
      options[j].addEventListener('change', function () {
        document.getElementById('giftBag').checked = false;
      });
    }
    giftBagCheckbox.addEventListener('change', function () {
      if (this.checked) {
        giftBagChecked();
      } else {
        giftBagUnchecked();
      }
    });
    return true;
  }
  return false;
}

function initGiftBagObserver() {
  // If it's already on the page, just attach and do nothing else.
  if (attachGiftBagListener()) {
    return;
  }

  const observer = new MutationObserver((mutationsList, observer) => {
    // Each time there's a change, check if giftBag now exists
    if (attachGiftBagListener()) {
      observer.disconnect();
    }
  });

  // Start observing the body for newly added elements
  observer.observe(document.body, { childList: true, subtree: true });
}

function giftBagChecked() {
  guaranteed();
}

function giftBagUnchecked() {
  checkDeliveryGuarantee();
}

// Initialize once the DOM is ready or your script runs
initGiftBagObserver();

function replacePrivacyPolicyWithLink() {
  // Ensure the form exists
  var klaviyoForm = document.querySelector('div.klaviyo-form');

  if (klaviyoForm) {
    // Check if the form already has been processed (avoid multiple runs)
    if (klaviyoForm.hasAttribute('data-processed')) {
      return;  // Skip further processing if already processed
    }

    // Find elements that contain the privacy policy text
    var elementsContainingPrivacyPolicy = Array.from(klaviyoForm.querySelectorAll('label')).filter(function(el) {
      return el.textContent.includes('I have read and accept privacy policy');
    });

    if (elementsContainingPrivacyPolicy.length > 0) {
      elementsContainingPrivacyPolicy[0].innerHTML = elementsContainingPrivacyPolicy[0].innerHTML.replace(
        /\>I have read and accept privacy policy/,
        '>I have read and accept&nbsp;<a href="https://www.thelittlelearnerstoys.com/policies/privacy-policy" style="color: #FFFFFF; text-decoration: underline;" target="_blank">privacy policy</a>'
      );

      // Mark the form as processed to prevent multiple executions
      klaviyoForm.setAttribute('data-processed', 'true');
    }
  }
}

// Run the function once on interval
var intervalId = setInterval(replacePrivacyPolicyWithLink, 500);

// Stop interval after a reasonable time (e.g., 5 seconds)
setTimeout(function() {
  clearInterval(intervalId);
}, 5000);
